<template>
  <div class="order__body">
    <div class="order__left pt-16 sm:pt-32">
      <orderForm ref="orderForm" />
      <!-- <div v-if="order.yokosoInfo && externalHotelSource.includes(order.source)" class="flex flex-wrap border border-grey-lightest rounded-sm mb-16 items-center">
        <div class="text-grey-darkest font-bold text-lg border-r-1 border-grey-lightest p-16 pr-24">{{ $t('peopleLimit') }}</div>
        <div class="p-16 pr-64 leading-lg text-sm font-bold">
          <div>{{ $t('adult') }}</div>
          <div v-if="yokosoChild(order)">{{ $t('child') }}</div>
        </div>
        <div class="p-16 leading-lg text-sm text-grey-darker">
          <div>{{ order.yokosoInfo.adultCount }} {{ $t('unit.perPerson') }}</div>
          <div v-if="yokosoChild(order)">
            <template v-for="(item, index) in yokosoChild(order)">
              <span :key="index">
                <span>{{ item.age }} {{ $t('yearsOld') }} ({{item.count}}{{ $t('unit.perPerson') }})</span>
                <span v-if="yokosoChild(order) && index + 1 < yokosoChild(order).length">, </span>
              </span>
            </template>
          </div>
        </div>
      </div>
      <div v-else-if="order.adultCount" class="flex flex-wrap border border-grey-lightest rounded-sm mb-16 items-center">
        <div class="text-grey-darkest font-bold text-lg border-r-1 border-grey-lightest p-16 pr-24">{{ $t('peopleLimit') }}</div>
        <div class="flex-1 p-16 leading-lg text-sm">
          <div class="flex">
            <span class="pax-label font-bold pr-16 whitespace-no-wrap">{{ $t('adult') }}</span>
            <span class="text-grey-darker">{{ order.adultCount }} {{ $t('unit.perPerson') }}</span>
          </div>
          <div class="flex">
            <span class="pax-label font-bold pr-16 whitespace-no-wrap">{{ $t('child') }}</span>
            <div v-if="order.childAges && order.childAges.length > 0" class="text-grey-darker">
              <template v-for="(item, index) in childAgesGroup">
                <span :key="index">
                  <span>{{ item.age }} {{ $t('yearsOld') }} ({{item.count}}{{ $t('unit.perPerson') }})</span>
                  <span v-if="childAgesGroup && index + 1 < childAgesGroup.length">, </span>
                </span>
              </template>
            </div>
            <div v-else>0 {{ $t('unit.perPerson') }}</div>
          </div>
        </div>
      </div> -->
      <!-- <div v-if="isMultipleCancelPolicy" class="hidden lg:block flex-none w-full p-8 mt-32 mb-0 text-center text-red bg-grey-lightest rounded-t-sm leading-sm" style="word-break: keep-all;">{{ $t('cart.cancelPolicyWarning') }}</div> -->
      <div class="OrderDetail mb-24">
        <orderDetailCardNew v-for="item in order.rooms" :key="item.id" :rooms="item" :order="order"></orderDetailCardNew>
        <orderAddonDetailCard :order="order" />
      </div>

      <!-- 寫國旅的位置 -->
      <orderTaiwanTravel v-if="!(isYokosoHotelOrHotelBeds || isQuarantineHotel) && this['order/taiwanTravelCanUseNum'] >= 0" />

      <!-- 優惠折扣/coupon的位置 -->
      <orderDiscount v-if="Object.keys(order).length" :premiumCoupon="order.premiumCoupon" :promoCouponCode="order.promoCouponCode" />

      <!-- 國旅卡 -->
      <orderTaiwanTravelCard v-if="order.isUseTaiwanTravel" />

      <div class="block lg:hidden p-16 sm:p-24 border border-grey-lighter rounded mt-16" style="border-radius: 20px;">
        <div class="flex flex-col sm:flex-row justify-between sm:items-center">
          <span class="leading-normal mb-8 sm:mb-0 font-medium">{{ $t('totalPrice') }}</span>
          <div class="aside__payment-count text-left sm:text-right">
            <div class="text-2xl text-blue mb-8 font-medium">
              <span v-if="isCurrencyConvert">{{ $t('priceAbout') }} </span>{{ currencySign }} {{ order.total | currencyConvert({inputCurrency: order.currency, listInteger: true}) }} <small class='text-sm'>({{ $t('includeTax') }})</small>
            </div>
            <div v-if="isCurrencyConvert" class="mt-4 text-grey-dark text-sm font-bold">({{ order.currency | currencySign }} {{ order.total | toCurrency }})</div>
          </div>
        </div>
      </div>

      <div class="p-16 sm:p-24 border-1 border-blue-light bg-blue-lightest rounded mt-16" style="border-radius: 20px;">
        <!-- <div class="warning-msg flex items-center mb-8">
          <i class="owl-status-triangle-warning text-orange text-2xl pr-4" />
          <span class="mb-4">{{ $t('addPeopleWarningMsg') }}</span>
        </div> -->
        <div class="flex justify-between flex-wrap">
          <div class="owl-checkbox-wrap">
            <label v-if="this['order/isUsingTaiwanTravel'] && this.selectedCoupon.code === 'travel_ticket_1000'" for="travelPolicyCheck">
              <input type="checkbox" id="travelPolicyCheck" v-model="isTravelPolicyChecked">
              <div class="owl-checkbox flex-no-shrink"></div>
              <span class="cursor-default leading-normal">
                <span>{{ $t('taiwanTravel.policyAgreement[0]') }}</span>
                <a class="text-blue-light cursor-pointer underline" @click.prevent="showTravelRule">
                  {{ $t('taiwanTravel.ruleTitle') }}
                </a>
                <span>{{ $t('taiwanTravel.policyAgreement[1]') }}</span>
              </span>
            </label>
            <label for="policyCheck" style="align-items: start;">
              <input type="checkbox" id="policyCheck" v-model="isPolicyChecked">
              <div class="owl-checkbox flex-no-shrink"></div>
              <span class="cursor-default leading-normal">
                <span>{{ $t('addPeopleWarningMsg') }}</span>
                <br />
                <span>{{ $t('policyAgreement')[0] }}</span>
                <router-link :to="{name: 'UserTerm'}" target="_blank" class="text-blue-light">{{ $t('termsOfUse') }}</router-link>
                <span> {{ $t('policyAgreement.and') }} </span>
                <a :href="`https://www.owlting.com/portal/about/privacy?lang=${externalLinkLang}`" class="text-blue-light" target="_blank">{{ $t('privacyPolicy') }}</a>
              </span>
            </label>
          </div>
        </div>
      </div>
      <div class="order__btn-group text-center mt-40 flex flex-col-reverse sm:flex-row justify-center items-center">
        <!-- <button class="btn btn-text btn-grey mt-16 sm:mt-0 w-full sm:w-auto" @click="goPre">{{ $t('preStep') }}</button> -->
        <template>
          <button class="btn btn-solid btn-blue sm:ml-16 w-full sm:w-auto" style="border-radius: 20px;" @click="submitForm" :disabled="isOrderSubmitting">{{ isOrderSubmitting ? $t('submitting') : $t('confirmToPay') }}</button>
        </template>
      </div>
    </div>
    <div class="order__right mt-32 lg:mt-0" :class="$route.name === 'OrderConfirmation' ? 'hidden' : ''">
      <orderAsideNew />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapGetters, mapMutations, mapActions } from 'vuex'

import orderAsideNew from '@/views/Order/components/OrderAsideNew'
import orderForm from '@/views/Order/components/OrderForm'
import orderDiscount from '@/views/Order/components/OrderDiscount'
import orderTaiwanTravel from '@/views/Order/components/OrderTaiwanTravel'
import orderTaiwanTravelCard from '@/views/Order/components/OrderTaiwanTravelCard'
import orderDetailCardNew from '@/components/orderDetailCardNew'
import orderAddonDetailCard from '@/components/orderAddonDetailCard'
import fullPageModal from '@/components/modals/fullPageModal'
import taiwanTravelPolicy from '@/components/taiwanTravelPolicy'
import localeMixin from '@/mixins/locale'
import yokosoMixin from '@/mixins/yokoso'

export default {
  name: 'OrderDetail',
  metaInfo () {
    return {
      title: '訂單詳情'
    }
  },
  mixins: [
    localeMixin,
    yokosoMixin
  ],
  components: {
    orderAsideNew,
    orderForm,
    orderDiscount,
    orderTaiwanTravel,
    orderDetailCardNew,
    orderTaiwanTravelCard,
    orderAddonDetailCard
  },
  data () {
    return {
      isOrderSubmitting: false
    }
  },
  beforeRouteLeave (to, from, next) {
    this['order/onSaveDiscount']({})
    next()
  },
  computed: {
    ...mapGetters({
      order: 'order/order',
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency',
      customer: 'order/customer',
      traveler: 'order/traveler',
      'search/totalNights': 'search/totalNights',
      selectedCoupon: 'order/selectedCoupon',
      'order/isPolicyChecked': 'order/isPolicyChecked',
      isYokosoHotel: 'yokoso/isYokosoHotel',
      isQuarantineHotel: 'order/isQuarantineOrder',
      'order/isUsingTaiwanTravel': 'order/isUsingTaiwanTravel',
      'order/isTravelPolicyChecked': 'order/isTravelPolicyChecked',
      'order/taiwanTravelCanUseNum': 'order/taiwanTravelCanUseNum',
      externalHotelSource: 'hotels/externalHotelSource'
    }),
    isYokosoHotelOrHotelBeds: function () {
      return this.externalHotelSource.includes(this.order.source)
    },
    isCurrencyConvert: function () {
      return this.order.currency !== this.selectedCurrency
    },
    childAgesGroup: function () {
      let result = []
      for (const age in _.groupBy(this.order.childAges)) {
        result.push({
          age: age,
          count: _.groupBy(this.order.childAges)[age].length
        })
      }
      return result
    },
    isMultipleCancelPolicy: function () {
      const plans = _.flatMap(this.order.rooms, room => room.plans)
      const result = _.groupBy(plans, plan => {
        return plan.cancelPolicy.title
      })
      return result && _.size(result) > 1
    },
    isPolicyChecked: {
      get () {
        return this['order/isPolicyChecked']
      },
      set (val) {
        this.$store.commit('order/SET_POLICY_CHECKED', val)
      }
    },
    isTravelPolicyChecked: {
      get () {
        return this['order/isTravelPolicyChecked']
      },
      set (val) {
        this.$store.commit('order/SET_TRAVEL_POLICY_CHECKED', val)
      }
    }
  },
  methods: {
    ...mapActions([
      'order/getOrder',
      'order/onSaveDiscount',
      'order/updateOrderInfo'
    ]),
    ...mapMutations([
      'order/SET_POLICY_CHECKED',
      'order/SET_TRAVEL_POLICY_CHECKED',
      'order/SET_TAIWAN_TRAVEL_CARD'
    ]),
    submitForm: async function () {
      Promise.all([this.$refs['orderForm'].onFormValidate()])
        .then(res => {
          if (!this.isPolicyChecked || (this['order/isUsingTaiwanTravel'] && (!this.isTravelPolicyChecked && this.selectedCoupon.code === 'travel_ticket_1000'))) {
            this.$alert(this.$t('confirmAllPolicies'), {
              type: 'warning',
              confirmButtonText: this.$t('ok')
            })
            return false
          }
          this.sendGtm()
          // Vue 2 版本用回呼函式方式
          this.$recaptcha('checkout')
            .then(token => {
              console.log('reCAPTCHA token:', token)
              this.updateOrderInfo(token)
            })
            .catch(err => {
              console.error('reCAPTCHA 驗證失敗', err)
            })
        })
    },
    updateOrderInfo: function (recaptchaToken) {
      this.isOrderSubmitting = true
      this['order/updateOrderInfo']({
        orderSerial: this.$route.query.orderSerial,
        orderToken: this.$route.query.orderToken,
        recaptchaToken
      }).then(res => {
        if (res.status && res.msg) {
        } else if (res) {
          this.$router.replace({
            name: 'OrderResult',
            query: {
              orderSerial: res.orderSerial,
              orderToken: res.orderToken
            }
          })
        }
      }).finally(() => {
        this.isOrderSubmitting = false
      })
    },
    showTravelRule () {
      this.$modal.show(fullPageModal, {
        // 輸入內容
        context: taiwanTravelPolicy
      },
      {
        adaptive: true,
        name: 'TravelPolicy',
        // clickToClose: false,
        // height: '95%',
        height: 'auto',
        width: '95%',
        maxWidth: 812,
        scrollable: true
      })
    },
    sendGtm: function () {
      // GTM
      let list = []
      const hotel = this.order?.hotel
      if (hotel) {
        _.each(this.order?.rooms, room => {
          _.each(room.plans, plan => {
            const count = plan.count
            const id = `hotel/${hotel.hotelUUID}/room/${room.id}/plan/${plan.id}`
            const name = `[${hotel.hotelName}] ${room.name} - ${plan.id}`
            list.push({
              id: id,
              sku: id,
              name: name,
              category: hotel.hotelName,
              list: hotel.hotelName,
              brand: room.name,
              variant: plan.id,
              price: plan.avgPrice,
              quantity: count * Number(this['search/totalNights'])
            })
            // Matomo
            // add the first product to the order
            // window._paq.push(['addEcommerceItem',
            //   id, // (required) SKU: Product unique identifier
            //   name, // (optional) Product name
            //   hotel.hotelName, // (optional) Product category. You can also specify an array of up to 5 categories eg. ["Books", "New releases", "Biography"]
            //   plan.avgPrice, // (recommended) Product price
            //   count * Number(this['search/totalNights']) // (optional, default to 1) Product quantity
            // ])
          })
        })
        // GTM GA4
        window.dataLayer.push({
          event: 'add_shipping_info',
          ecommerce: {
            coupon: '',
            currency: 'TWD',
            value: this.order?.total
          }
        })

        let ecDataLayer = {
          'event': 'checkout',
          'ecommerce': {
            'checkout': {
              'actionField': {
                'step': 2,
                'affiliation': this.order?.hotel.hotelName
              },
              'products': list
            }
          }
        }
        window.dataLayer.push(ecDataLayer)
      }
    }
  },
  mounted () {
    // this['order/getOrder']()
    // this.$recaptcha.showBadge()
  },
  beforeDestroy () {
    this['order/SET_TRAVEL_POLICY_CHECKED'](false)
    this['order/SET_POLICY_CHECKED'](false)
    this['order/SET_TAIWAN_TRAVEL_CARD'](false)
  }
}
</script>

<style lang="sass" scoped>
.pax-label
  flex: 0 0 104px
</style>
